import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SeoService } from './seoService/seo.service';
import { filter, map, mergeMap } from 'rxjs/operators';
declare let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ipaam-site';
  showMenu: boolean;
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private seoService: SeoService) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route: any) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route: any) => route.outlet === 'primary'),
        mergeMap((route: any) => route.data)
      )
      .subscribe((event) => {
        if (event['title']) {
          this.seoService.updateTitle(event['title']);
        }
        if (event['keywords']) {
          this.seoService.updateKeyword(event['keywords']);
        }
        if (event['description']) {
          this.seoService.updateDescription(event['description']);
        }
      });
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-X3PZ765B83', {
          page_path: event.urlAfterRedirects
        });
      }
    });
  }
}
